export const config = {
  validateLocally: true,
  timeout: 120000,
};
